import { Component, OnInit } from '@angular/core';

@Component({
  template: ''
})
export class newanalysiscomponent implements OnInit {
  ngOnInit() {
    sessionStorage.setItem('ffs:newAnalysisSelected', 'true');
    sessionStorage.removeItem('ffs:lastAssessmentPath');
    window.location.href = '/';
  }
}